<script setup>
import { format } from '@formkit/tempo'
import Tag from '@components/global/Tag.vue'
import Button from '@components/forms/Button.vue'

const props = defineProps({
	article: {
		type: Object,
		required: true,
	},
	compact: {
		type: Boolean,
		default: false,
	},
	featured: {
		type: Boolean,
		default: false,
	},
})
</script>

<template>
	<div class="group">
		<router-link :class="['relative flex flex-col gap-3 overflow-hidden rounded-xl bg-black p-2 text-white lg:flex-row', { 'grid-cols-2 lg:grid': featured }, { 'flex-col! gap-1!': compact }]" :to="{ name: 'article', params: { slug: article.slug } }">
			<div :class="['aspect-video shrink-0 overflow-hidden rounded-lg', { 'lg:h-64': !featured && !compact }]">
				<img :class="['object-cover transition-transform duration-300 group-hover:scale-105', { 'h-full w-full': featured }]" :src="article.image" />
			</div>
			<div :class="['flex flex-col justify-around gap-5 p-3', { 'gap-3! p-2!': compact }]">
				<div class="flex gap-4">
					<div class="flex flex-row items-center gap-2">
						<i class="far fa-calendar text-snk-blue-500"></i>
						<p>{{ format({ date: article.published_at, format: 'medium', tz: 'UTC' }) }}</p>
					</div>
				</div>
				<div class="flex flex-row justify-between gap-2">
					<h6 class="leading-none">{{ article.title }}</h6>
				</div>
				<p class="line-clamp-2" v-if="!compact">{{ article.short_description }}</p>
				<div class="flex gap-2" v-if="!compact">
					<Button class="primary solid">Read More</Button>
				</div>
			</div>
		</router-link>
	</div>
</template>
